import React from 'react';
import { useTranslation } from 'react-i18next';

import { LucideNavIcons } from '../../../icons/lucideNavIcons';
import ProjectNameHeader from '../project-name-header/ProjectNameHeader';

import scss from '../project-name-header/ProjectNameHeader.module.scss';

function ProjectRequestHeader() {
  const { t } = useTranslation('projectRequest');

  return (
    <ProjectNameHeader
      icon={LucideNavIcons.ProjectRequest}
      selector={() => null}
      defaultName={t('requestNewProject')}
      iconProps={{ disableCommonStyles: true, className: scss.iconStroke }}
    />
  );
}

export default ProjectRequestHeader;
